import styled from 'styled-components'

export const PartPaymentWidget = styled.div<{ $insideSummaryPanel?: boolean }>`
  ${(props) =>
    props.$insideSummaryPanel
      ? 'margin: 25px 0 15px;'
      : `display: block;
    width: 92vw;
    max-width: 400px;
    margin-bottom: 30px;
    align-self: flex-end;`}
`
